import styled from 'styled-components';
import { media, spacing } from '~/theme';

export const ErrorContainer = styled.div`
    margin: ${spacing.spacing7} ${spacing.spacing0};
`;
export const Form = styled.form`
    input {
        width: 100%;
    }
    p {
        @media ${media.medium} {
            max-width: 48rem;
        }
    }
    figcaption {
        margin-top: ${spacing.spacing4};
        @media ${media.medium} {
            max-width: 30rem;
        }
    }

    & {
        @media ${media.medium} {
            max-width: 48rem;
        }
    }

    [id^='primary-phone'] {
        max-width: none;
    }
`;
